<template>
  <b-alert
    :variant="variant"
    show
  >
    <div
      class="alert-body"
      :class="bodyClass"
    >
      <div
        class="d-flex"
        :class="{ 'align-items-center': itemsCenter }"
      >
        <span
          v-if="iconName"
          class="alert-icon"
          :style="iconColor ? `color:${iconColor}` : ''"
        >
          <GjIcon
            :name="iconName"
            size="25"
          />
        </span>
        <template v-if="itemsCenter">
          <span :class="`alert-text`">
            <slot>{{ text }} </slot>
          </span>
        </template>
        <span
          v-else
          :class="`${textClass} alert-text`"
        >
          <slot>{{ text }} </slot>
        </span>
      </div>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'CustomAlert',
  props: {
    variant: {
      type: String,
      default: 'default',
    },
    iconName: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: null,
    },
    itemsCenter: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    bodyClass: {
      type: String,
      default: '',
    },
  },
}
</script>
